import React from "react";

const PaginationPrevIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 9 13"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="currentColor"
        fillRule="evenodd"
      >
        <g
          id="Apple-TV-Copy-5"
          transform="translate(-714.000000, -3166.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <g id="Group-7" transform="translate(696.000000, 3149.000000)">
            <g
              id="down-chevron-copy-4"
              transform="translate(22.660000, 23.644000) rotate(-270.000000) translate(-22.660000, -23.644000) translate(16.516000, 19.847536)"
            >
              <polygon
                id="Path"
                points="10.8390244 -5.96188678e-13 6.14400024 4.69502419 1.44897606 -5.96188678e-13 0 1.44892806 6.14400024 7.5929283 12.2880005 1.44892806"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PaginationPrevIcon;
